window.addEventListener("DOMContentLoaded", () => {
  $(document).ready(function() {
    let activeTabId = "tab1";
    let hasLoaded = false;

    // Parse bundle strings into JSON objects
    console.log('SPO Cart Properties: Parsing bundle strings');
    
    // Parse device bundle
    let spo_device_bundle_json = [];
    if (typeof window.spo_device_bundle !== 'undefined' && window.spo_device_bundle && window.spo_device_bundle !== 'null' && window.spo_device_bundle !== '') {
      try {
        spo_device_bundle_json = window.spo_device_bundle;
        console.log('spo_device_bundle_json parsed successfully:', spo_device_bundle_json);
      } catch (e) {
        console.error('Error parsing spo_device_bundle:', e, 'Raw value:', window.spo_device_bundle);
        spo_device_bundle_json = [];
      }
    } else {
      console.log('spo_device_bundle is empty or null');
    }
    
    // Parse flavor bundle
    let spo_flavor_bundle_json = [];
    if (typeof window.spo_flavor_bundle !== 'undefined' && window.spo_flavor_bundle && window.spo_flavor_bundle !== 'null' && window.spo_flavor_bundle !== '') {
      try {
        spo_flavor_bundle_json = window.spo_flavor_bundle;
        console.log('spo_flavor_bundle_json parsed successfully:', spo_flavor_bundle_json);
      } catch (e) {
        console.error('Error parsing spo_flavor_bundle:', e, 'Raw value:', window.spo_flavor_bundle);
        spo_flavor_bundle_json = [];
      }
    } else {
      console.log('spo_flavor_bundle is empty or null');
    }
    
    // Parse accessory bundle
    let spo_accessory_bundle_json = [];
    if (typeof window.spo_accessory_bundle !== 'undefined' && window.spo_accessory_bundle && window.spo_accessory_bundle !== 'null' && window.spo_accessory_bundle !== '') {
      try {
        spo_accessory_bundle_json = window.spo_accessory_bundle;
        console.log('spo_accessory_bundle_json parsed successfully:', spo_accessory_bundle_json);
      } catch (e) {
        console.error('Error parsing spo_accessory_bundle:', e, 'Raw value:', window.spo_accessory_bundle);
        spo_accessory_bundle_json = [];
      }
    } else {
      console.log('spo_accessory_bundle is empty or null');
    }

    // Disable scroll - prevent auto scroll when variant changes
    const originalScrollTo = window.scrollTo;
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    
    // Override scroll methods with empty functions
    window.scrollTo = function() {};
    Element.prototype.scrollIntoView = function() {};
    
    // Re-enable scroll methods after section re-render
    $(document).on('shopify:section:load', function() {
      // Restore the original methods
      window.scrollTo = originalScrollTo;
      Element.prototype.scrollIntoView = originalScrollIntoView;
    });

    // Cart Properties Functions
    const addDeviceProperties = (form, deviceBundleJson) => {
      if (!deviceBundleJson || deviceBundleJson.length === 0) return;
      
      // Get selected device from DOM - try multiple selectors for different layouts
      const selectedDevice = document.querySelector('.device.selected, .device[data-is-variant-selected="true"], .device[class*="selected"]');
      
      // If no device selector found, try to get device info from product variant or bundle
      if (!selectedDevice) {
        // For SPO clean version, we might get device info from the bundle or product context
        if (deviceBundleJson.length > 0) {
          // Use the first device as default or get from product context
          const deviceData = deviceBundleJson[0];
          
          const deviceInput = $('<input>', {
            type: 'hidden',
            name: 'properties[Device]',
            value: deviceData.title,
            form: form.attr('id')
          });
          form.append(deviceInput);
          
          const deviceIdInput = $('<input>', {
            type: 'hidden',
            name: 'properties[_Device ID]',
            value: deviceData.id.toString(),
            form: form.attr('id')
          });
          form.append(deviceIdInput);
          
          const deviceHandleInput = $('<input>', {
            type: 'hidden',
            name: 'properties[_Device Handle]',
            value: deviceData.handle,
            form: form.attr('id')
          });
          form.append(deviceHandleInput);
        }
        return;
      }
      
      const deviceName = selectedDevice.getAttribute('data-name') || 
                        selectedDevice.querySelector('.variant_title')?.textContent ||
                        selectedDevice.querySelector('p')?.textContent;
      if (!deviceName) return;
      
      // Find device in bundle JSON
      const deviceData = deviceBundleJson.find(device => 
        device.title === deviceName || 
        device.handle === deviceName.toLowerCase().replace(/\s+/g, '-')
      );
      
      if (deviceData) {
        // Add device properties
        const deviceInput = $('<input>', {
          type: 'hidden',
          name: 'properties[Device]',
          value: deviceData.title,
          form: form.attr('id')
        });
        form.append(deviceInput);
        
        const deviceIdInput = $('<input>', {
          type: 'hidden',
          name: 'properties[_Device ID]',
          value: deviceData.id.toString(),
          form: form.attr('id')
        });
        form.append(deviceIdInput);
        
        const deviceHandleInput = $('<input>', {
          type: 'hidden',
          name: 'properties[_Device Handle]',
          value: deviceData.handle,
          form: form.attr('id')
        });
        form.append(deviceHandleInput);
      }
    };

    const addFlavorProperties = (form, flavorBundleJson) => {
      // Use bundle data directly - no need to check DOM selections
      if (!Array.isArray(flavorBundleJson) || flavorBundleJson.length === 0) {
        console.log('SPO Cart Properties: No flavor bundle data available');
        return;
      }
      
      let flavorIndex = 1;
      let childVariantLines = {};
      
      console.log('SPO Cart Properties: Processing flavor bundle data:', flavorBundleJson);
      
      // Process each flavor in the bundle (similar to custom-journey but using bundle data)
      flavorBundleJson.forEach(function(flavorData, index) {
        const flavorName = flavorData.title;
        const flavorId = flavorData.variants[0].id; // Use first variant ID
        const flavorSku = flavorData.variants[0].sku;
        const quantity = 1; // Default quantity for bundle items
        
        console.log('SPO Cart Properties: Processing flavor:', flavorName, 'ID:', flavorId);
        
        // Add flavor properties (same format as custom-journey)
        const inputIndex = flavorIndex;
        const inputName = `properties[Flavor ${inputIndex}]`;
        const inputValue = `${quantity}x ${flavorName}`;
        
        const skuInputName = `properties[_SKU ${flavorSku}]`;
        const skuInputValue = `${quantity}x ${flavorName}`;
        
        const qtyInputName = `properties[_Quantity${inputIndex}]`;
        const qtyInputValue = `${quantity}`;
        
        const hiddenInput = $('<input>', {
          type: 'hidden',
          name: inputName,
          value: inputValue,
          form: form.attr('id')
        });
        form.append(hiddenInput);
        
        const hiddenInputSku = $('<input>', {
          type: 'hidden',
          name: skuInputName,
          value: skuInputValue,
          form: form.attr('id')
        });
        form.append(hiddenInputSku);
        
        const hiddenInputQty = $('<input>', {
          type: 'hidden',
          name: qtyInputName,
          value: qtyInputValue,
          form: form.attr('id')
        });
        form.append(hiddenInputQty);
        
        flavorIndex += 1;
        
        // Add to child variant lines for subscription data
        if (childVariantLines[flavorId]) {
          childVariantLines[flavorId] += quantity;
        } else {
          childVariantLines[flavorId] = quantity;
        }
      });
      
      // Add child lines property (same as custom-journey)
      if (Object.keys(childVariantLines).length > 0) {
        const childLinesInput = $('<input>', {
          type: 'hidden',
          form: form.attr('id'),
          name: 'properties[_childLines]'
        }).val(JSON.stringify(childVariantLines));
        form.append(childLinesInput);
        console.log('SPO Cart Properties: Added child lines:', childVariantLines);
      }
    };

    const addAccessoryProperties = (form, accessoryBundleJson) => {
      if (!accessoryBundleJson || accessoryBundleJson.length === 0) return;
      
      // Process selected accessories - try multiple selectors
      const selectedAccessories = document.querySelectorAll('.accessory.selected, .accessory[class*="selected"], .accessory .select-button.selected');
      
      if (selectedAccessories.length === 0) {
        // No accessories selected, return early
        return;
      }
      
      selectedAccessories.forEach((accessory, index) => {
        const accessoryName = accessory.getAttribute('data-name') || 
                             accessory.querySelector('.variant_title')?.textContent ||
                             accessory.querySelector('p')?.textContent;
        
        if (accessoryName) {
          // Find accessory in bundle JSON
          const accessoryData = accessoryBundleJson.find(acc => 
            acc.title === accessoryName || 
            acc.handle === accessoryName.toLowerCase().replace(/\s+/g, '-')
          );
          
          const displayName = accessoryData ? accessoryData.title : accessoryName;
          
          // Add accessory properties
          const accessoryInput = $('<input>', {
            type: 'hidden',
            name: `properties[Accessory ${index + 1}]`,
            value: displayName,
            form: form.attr('id')
          });
          form.append(accessoryInput);
          
          if (accessoryData) {
            const accessoryIdInput = $('<input>', {
              type: 'hidden',
              name: `properties[_Accessory ${index + 1} ID]`,
              value: accessoryData.id.toString(),
              form: form.attr('id')
            });
            form.append(accessoryIdInput);
          }
        }
      });
    };

    // Enhanced Add to Cart functionality
    const handleAddToCart = (e) => {
      console.log('SPO: handleAddToCart called', e);
      e.preventDefault();
      
      // Handle subscription plan selection (similar to custom-journey)
      const activeTab = $('.fum_tab-radio:checked').attr('id');
      if (activeTab === 'tab1-radio') {
        // Subscription tab
        const subscriptionGroup = document.querySelector('[data-loop-widget-selling-plan-group]');
        if (subscriptionGroup) {
          subscriptionGroup.click();
        }
      } else {
        // One-time purchase tab
        const onetimeOption = document.querySelector('[data-loop-widget-onetime-purchase-option]');
        if (onetimeOption) {
          onetimeOption.click();
        }
      }
      
      const form = $('product-form.product-form form');
      if (!form.length) {
        console.warn('SPO Cart Properties: No product form found');
        return;
      }
      
      console.log('SPO Cart Properties: Starting cart properties processing');
      
      // Remove existing properties
      form.find('input[name^="properties"]').remove();
      
      // Add device properties
      if (spo_device_bundle_json && spo_device_bundle_json.length > 0) {
        console.log('SPO Cart Properties: Adding device properties', spo_device_bundle_json);
        addDeviceProperties(form, spo_device_bundle_json);
      } else {
        console.log('SPO Cart Properties: No device bundle data available');
      }
      
      // Add flavor properties from bundle data
      console.log('SPO Cart Properties: Processing flavor bundle data:', spo_flavor_bundle_json);
      addFlavorProperties(form, spo_flavor_bundle_json);
      
      // Add accessory properties
      if (spo_accessory_bundle_json && spo_accessory_bundle_json.length > 0) {
        console.log('SPO Cart Properties: Adding accessory properties', spo_accessory_bundle_json);
        addAccessoryProperties(form, spo_accessory_bundle_json);
      } else {
        console.log('SPO Cart Properties: No accessory bundle data available');
      }
      
      // Log final form data for debugging
      const finalProperties = form.find('input[name^="properties"]');
      console.log('SPO Cart Properties: Final cart properties count:', finalProperties.length);
      finalProperties.each(function() {
        console.log('SPO Cart Properties:', $(this).attr('name'), '=', $(this).val());
      });
      
      // Submit the form directly (bundle data is fixed)
      console.log('SPO Cart Properties: Submitting form with bundle data');
      form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    };

    const sellingPlanGroupController = (subscription) => {
      const subscriptionGroup = document.querySelector('[data-loop-widget-selling-plan-group]');
      const onetimeOption = document.querySelector('[data-loop-widget-onetime-purchase-option]');
      if (subscription) {
        if (subscriptionGroup) {
          subscriptionGroup.click();
        }
      } else {
        if (onetimeOption) {
          onetimeOption.click();
        }
      }
    }

    const updateProductInfo = () => {
      const productInfoSectionId = 
      fetch(`${window.location.pathname}?${urlParams.toString()}&section_id=product-info`)
        .then(response => response.text())
        .then(data => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const productInfo = html.querySelector("#shopify-section-product-info");
          document.querySelector("#shopify-section-product-info").innerHTML = productInfo.innerHTML;
        })
        .catch(error => console.error("Error updating product-info section:", error));
    }

    const updateATCButton = () => {
      const atcButton = document.querySelector(".add-to-cart");
      const atcButtonText = document.querySelectorAll(".product_buy_info");

      atcButtonText.forEach(text => {
        text.textContent = "Add to Cart";
      });
    }

    const updateSelectedVariant = (t) => {
      console.log("UPDATE SELECTED VARIANT", t);
      const tabVariantId = t.getAttribute("data-variant-id");
      const tabVariantName = t.getAttribute("data-variant-name");

      if (tabVariantId) {
        $(`.product-form__input:eq(0) input[value="${tabVariantName}"]`).click();
      }
    }

    const updateSPOTabStyles = (activeTabId) => {
      const tab1 = document.querySelector("[data-fum_tab='tab1']");
      const tab2 = document.querySelector("[data-fum_tab='tab2']");
      const tab1Radio = document.getElementById("tab1-radio");
      const tab2Radio = document.getElementById("tab2-radio");
      // tab contents
      const tab1Content = document.getElementById("tab1");
      const tab2Content = document.getElementById("tab2");
      if (activeTabId === "tab1") {
        // Style active subscription tab
        if (tab1) {
          tab1.style.backgroundColor = "#f7f782";
          tab1.style.border = "1.5px solid #3f603f";
          tab1.style.borderBottom = "1.5px solid #f7f782";
          tab1.style.borderTopRightRadius = "10px";
          tab1.style.zIndex = "2";
          tab1.classList.remove("fum_tab-inactive");

          if (tab1Radio) {
            tab1Radio.checked = true;
          }

          if (tab1Content) {
            tab1Content.style.display = "block";
          }
        }
        if (tab2) {
          tab2.style.backgroundColor = "#ffffc4";
          tab2.style.border = "1.5px solid transparent";
          tab2.style.borderBottom = "1.5px solid #3f603f";
          tab2.style.borderTopLeftRadius = "";
          tab2.style.zIndex = "1";
          tab2.classList.remove("fum_tab-active");

          if (tab2Radio) {
            tab2Radio.checked = false;
          }

          if (tab2Content) {
            tab2Content.style.display = "none";
          }
        }
      } else if (activeTabId === "tab2") {
        // Style active onetime tab
        if (tab1) {
          tab1.style.backgroundColor = "#FDFCF5";
          tab1.style.border = "1.5px solid transparent";
          tab1.style.borderBottom = "1.5px solid #3f603f";
          tab1.style.borderTopLeftRadius = "10px";
          tab1.style.zIndex = "1";
          tab1.classList.remove("fum_tab-inactive");

          if (tab1Radio) {
            tab1Radio.checked = false;
          }

          if (tab1Content) {
            tab1Content.style.display = "none";
          }
        }
        if (tab2) {
          tab2.style.backgroundColor = "rgba(63, 96, 63, 0.10)";
          tab2.style.border = "1.5px solid #3f603f";
          tab2.style.borderBottom = "transparent";
          tab2.style.borderTopLeftRadius = "10px";
          tab2.style.zIndex = "2";
          tab2.classList.add("fum_tab-active");

          if (tab2Radio) {
            tab2Radio.checked = true;
          }

          if (tab2Content) {
            tab2Content.style.display = "block";
          }
        }
      }
    }

    const spoTabs = () => {
      const fumTabs = document.querySelectorAll(".fum_tab");
      const tab1 = document.querySelector("[data-fum_tab='tab1']");
      const tab2 = document.querySelector("[data-fum_tab='tab2']");
      
      fumTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const tabId = tab.getAttribute("data-fum_tab");
          const tabVariantId = tab.getAttribute("data-variant-id");
          const tabVariantName = tab.getAttribute("data-variant-name");
          
          updateSPOTabStyles(tabId);
          sellingPlanGroupController(tabId === "tab1");
          updateATCButton();
          updateSelectedVariant(tab);
          hasLoaded = true;
        });
      });
    }

    const selectDefaultTab = () => {
      const defaultTab = document.querySelector("[data-fum_tab='tab1']");
      if (defaultTab) {
        defaultTab.click();
        console.log("SELECTED DEFAULT TAB");
      }
    }

    spoTabs();
    
    // Add event listener for add to cart button (direct binding like custom-journey)
    const addToCartButtons = $('.add-to-cart, .product-form__submit');
    console.log('SPO: Found add to cart buttons:', addToCartButtons.length, addToCartButtons);
    addToCartButtons.click(handleAddToCart);
    
    // Fallback: Also use delegated event listener in case buttons are added dynamically
    $(document).on('click', '.add-to-cart, .product-form__submit', handleAddToCart);
    
    // No need for flavor selection event listeners since button state is not conditional
    
    setInterval(() => {
      updateATCButton();
    }, 1000);
  });
});